import { Dayjs } from 'dayjs';
import Fetch from '../utils/fetch';
import { settings } from '../settings';
import { CapacityInfoData } from '../types/capacityTypes';
import { ERROR } from '../const/error';

export const fetchCapacityInfo = async (
  deliveryDate: Dayjs
): Promise<CapacityInfoData> => {
  try {
    const date = deliveryDate.format('YYYY-MM-DD');
    const url = `${settings.newApiUrl}/capacity?date=${date}`;
    const response = await Fetch.get({ url });
    if (response.ok) return (await response.json()) as CapacityInfoData;
    return { stores: [], regions: [] };
  } catch (e) {
    console.log(ERROR.FETCH_CAPACITY_INFO, e);
    return {
      stores: [],
      regions: [],
    };
  }
};
